import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ButtonWithIcon } from '@zoopla/blueprint-button-with-icon';

export const StyledButtonWithLoading = styled(ButtonWithIcon)<{
    isLoading?: boolean;
}>(
    ({ theme: { spacing }, isLoading }) => css`
        // this value allows us to maintain the correct button height when switching to the loading icon
        // default svg height is 48px
        ${isLoading &&
        `
            svg {
                margin-top: -${spacing['24px']};
                margin-bottom: -${spacing['24px']};
            }
        `}
    `
);
